<span class="filter-pill" [ngClass]="pillClass" [class.pill-x-armed]="pillXArmed" [attr.title]="item?.option[item?.displayName]">
    {{item?.option[item?.displayName]}}
    <span class="pill-x" (click)="onDeleteHandler()" (mouseenter)="onPillXEnter()" (mouseleave)="onPillXLeave()" *ngIf="!item?.disabled">&times;</span>
</span>
